<template>
    <div class="form-overlay music-content" :class="position">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :ref="`music-preview`"></audio>
        <div class="steep1" v-if="musicSelected">
            <div class="content">
                <div class="list-item hide-scrollbar">
                    <!-- <span class="loader" v-if="false"></span> -->
                    <div 
                        class="item"
                        style="margin-bottom: 0px;" 
                    >
                        <div 
                            class="img" 
                            @click.stop="toggleMusic(musicSelected)" 
                            :class="{play : (musicSelected.track && urlMusicPlaying == musicSelected.track.progressive_download_url) || (musicSelected.original_sound && urlMusicPlaying == musicSelected.original_sound.progressive_download_url)}">
                            <img :src="musicSelected.track ? musicSelected.track.cover_artwork_thumbnail_uri : musicSelected.original_sound.ig_artist.profile_pic_url" alt="">
                        </div>
                        
                        <div class="info">
                            <p class="name">{{musicSelected.track ? musicSelected.track.title : musicSelected.original_sound.original_audio_title }}</p>
                            <p class="author">{{musicSelected.track ? musicSelected.track.display_artist : musicSelected.original_sound.ig_artist.full_name }}</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="removeMusic"></i>
                    </div>

                    <template>
                        <CursorMusic
                            :music="musicSelected"
                            :defaultRangeDuration="models.duration.toString()"
                            :defaultStart="models.start"
                            :durationLock="durationLock"
                            @rangeDurationChange="rangeDurationChange"
                            @startChange="startChange"
                        />

                        <div v-if="!isProd" class="balance">
                            <h4>{{ $t('dash.post-creator.music.balance') }}</h4>
                            <div class="inputRange">
                                <input type="range" min="-1" max="1" step="0.01" v-model="balance">
                            </div>
                            <div class="labels">
                                <span>{{ $t('dash.post-creator.music.post-sound') }}</span>
                                <span>{{ $t('dash.post-creator.music.music-sound') }}</span>
                            </div>
                        </div>
                    </template>
                   
                
                </div>
            </div>
        </div>
        
        <div class="steep2" v-else>
            <div class="content">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input :placeholder="$t('dash.post-creator.overlay.search-music')" v-model="textSearch" v-on:keyup.enter="sendSearchMusic">
                </div>
                <div v-if="!textSearch" class="navigation">
                    <div v-for="[key, feed] in Object.entries(feeds)" @click="selectFeed(key)" class="item-nav" :class="{active: selectedFeed === key}">{{ feed.name }}</div>
                </div>
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <p v-else-if="textSearch && filteredListMusicsAvailable.length === 0" class="no-result">{{ $t('dash.post-creator.overlay.no-music') }}</p>
                    <template v-else>
                        <div class="item" v-for="(music, index) in (filteredListMusicsAvailable.length ? filteredListMusicsAvailable : filteredTrendMusics)" @click="selectMusic(music)" :key="`music${index}`">
                            <div 
                                class="img" 
                                @click.stop="toggleMusic(music)" 
                                :class="{play : (music.track && urlMusicPlaying == music.track.progressive_download_url) || (music.original_sound && urlMusicPlaying == music.original_sound	.progressive_download_url)}"
                            >
                                <img :src="music.track ? music.track.cover_artwork_thumbnail_uri : music.original_sound.ig_artist.profile_pic_url" alt="">
                            </div>
                            
                            <div class="info">
                                <p class="name">{{music.track ? music.track.title : music.original_sound.original_audio_title }}</p>
                                <p class="author">{{music.track ? music.track.display_artist :music.original_sound.ig_artist.full_name }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="btn-secondary" @click="close">{{ $t('dash.button.close') }}</div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import CursorMusic from '../cursorMusic.vue';
    import mixinPost from '@/components/mixins/Posts.vue'

    export default {
        mixins: [mixinPost],
        components: {
            CursorMusic,
        },
        props: {
            musicSelected: {
                type: Object,
                default: undefined 
            },
            position: {
                type: String,
                default: 'left'
            },
            durationLock: Number,
            allowOriginalSound: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                textSearch : '',
                balance : 0,
                lastIdEvent : 0,
                stateLoader : false,
                listMusicsAvailable : [],
                timeoutInitSearch : null,
                urlMusicPlaying : null,
                selectedFeed: "forYou",

                models : {
                    duration: this.musicSelected && this.musicSelected.duration ? this.musicSelected.duration : 15000,
                    start: this.musicSelected && this.musicSelected.start ? this.musicSelected.start : 0,
                }      
            }
        },

        mounted () {
            EventBus.$on('resultSearchFromSelectMusic', this.receveidMusic);
            if (!this.musicSelected && !this.textSearch) {
                this.fetchMusicFeeds();
            }
        },

        methods: {
            rangeDurationChange(data) {
                console.log("duration change", data)
                this.models.duration = data
            },
            startChange(data) {
                console.log("start change", data)
                this.models.start = data
            },
            async fetchMusicFeeds() {
                this.stateLoader = true;
                return new Promise(async (resolve, reject) => {
                    if (!this.dataInstagramDefault.musics.forYou.length || !this.dataInstagramDefault.musics.topTrends.length) {
                        const page = this.pagesSelected.find(p => p.story_config && p.story_config.created && p.network == 'instagram')
                        let data = this.dataInstagramDefault;
                        try {
                            if (!this.dataInstagramDefault.musics.forYou.length) {
                                const musicsReponse = (await this.getTrendMusicInstagram(page.id)).body.musics
                                if (Array.isArray(musicsReponse) && musicsReponse.length) data.musics.forYou = musicsReponse
                            }
                            if (!this.dataInstagramDefault.musics.topTrends.length) {
                                const musicsReponse = (await this.getTrendMusicInstagram(page.id, "topTrends")).body.musics
                                if (Array.isArray(musicsReponse) && musicsReponse.length) data.musics.topTrends = musicsReponse
                            }
                        } catch (error) {
                            reject();
                        }
                        this.$store.commit('postCreator/updateDataStoryMakerDefault', data);
                    }
                    resolve(null);
                })
                .finally(() => {
                    this.stateLoader = false;
                })
            },

            sendSearchMusic() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchFromSelectMusic",this.textSearch,this.lastIdEvent)
            },

            receveidMusic(musics,idEvent) {
                if (this.lastIdEvent == idEvent) {
                    this.listMusicsAvailable = musics || []
                    this.stateLoader = false
                }
            },

            selectFeed(feed) {
                this.selectedFeed = feed;
            },

            selectMusic(music) {
                const progressive_download_url = (music.track || music.original_sound).progressive_download_url;
                if (this.urlMusicPlaying !== progressive_download_url) this.toggleMusic()
                EventBus.$emit("eventClickSelectMusic",music)
            },

            removeMusic() {
                this.toggleMusic()
                EventBus.$emit("eventRemoveSelectMusic")
                this.fetchMusicFeeds()
            },
      
            toggleMusic(music) {
                let audio = this.$refs['music-preview'];

                if (!music) {
                    this.urlMusicPlaying = null;
                    audio.pause();
                    return;
                }

                const progressive_download_url = (music.track || music.original_sound).progressive_download_url;
                if (progressive_download_url === audio.src) {
                    if (audio.paused) {
                        audio.play();
                        this.urlMusicPlaying = progressive_download_url;
                    } else {
                        audio.pause();
                        this.urlMusicPlaying = null;
                    }
                } else {
                    audio.src = progressive_download_url;
                    audio.currentTime = (music.track ? music.track.highlight_start_times_in_ms[0] : 0) / 1000;
                    this.urlMusicPlaying = progressive_download_url;
                    audio.play();
                }
            },

            close() {
                if (this.musicSelected) {
                    EventBus.$emit("eventClickSelectMusic",{
                        ...this.musicSelected,
                        duration: this.models.duration,
                        start: this.models.start,
                    })
                }
                this.$emit('close')
            }
        },

        computed: {
            feeds() {
                return {
                    forYou: { name: this.$t('dash.post-creator.music.for-you') },
                    topTrends: { name: this.$t('dash.post-creator.music.popular') },
                }
            },

            dataInstagramDefault() {
                return this.$store.getters['postCreator/dataStoryMakerDefault'];
            },

            // Reel-only "remix another Reel's audio" results (music.original_sound) can't be
            // attached to an image/carousel post - Instagram's media/configure rejects it every
            // time. allowOriginalSound is false for those posts so we filter them out here rather
            // than letting them be picked and fail on publish.
            filteredListMusicsAvailable() {
                return this.listMusicsAvailable.filter(m => this.allowOriginalSound || !m.original_sound)
            },
            filteredTrendMusics() {
                const list = this.dataInstagramDefault.musics[this.selectedFeed] || []
                return list.filter(m => this.allowOriginalSound || !m.original_sound)
            },
             
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            isProd() {
                return process.env.VUE_APP_API_HOST == 'https://api.saas.mashup-web.com'
            }
        },

        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.toggleMusic()
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchMusic()
                },1000)
            },
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectMusic', this.receveidMusic);
            const audio = this.$refs['music-preview']
            if (audio) {
                audio.pause()
                audio.removeAttribute('src')
                audio.load()
            }
        }
    }
</script>

